import Vue from 'vue';
import 'isomorphic-fetch';
import EUINotifications from '@eui-plugin/event-bus-notifications';
import Auth0 from '@eui-util/auth0-plugin';
import Auth0Guard from '@eui-util/auth0-guard';
import {
  SAIUnsupportedBrowser,
  storeQueryCookiesGuard,
  SAIAlert,
  openSaiDialog,
  openSaiFullScreenDialog
} from 'ecx.saigon.ui.common';
import { parseDate, parseTimestamp } from '@eui-util/date';
import './styles/icons/style.css';
import './styles/index.sass';
import router from '../src/router';
import RouteNames from './router/route-names';
import * as Constants from './utils/constants';
import store from './store';
import MainApp from './main-app.vue';
import Vuelidate from 'vuelidate';
import VueMeta from 'vue-meta';
import { getEnv, setEnv, isBrowserValid } from 'ecx.saigon.ui.common';
import VueGtm from 'vue-gtm';
import onRedirectCallback from './router/on-redirect-callback';
import VueCurrencyFilter from 'vue-currency-filter';
import { Notify, Dialog } from 'quasar';
import EUINotify from '@eui-plugin/notify-popup';
import Eclipx from '@eui-plugin/vue-eclipx';
import { euiThemes } from '@eui-mixin/theme';
import loadScript from '@eui-util/load-script';

async function mount() {
  if (!isBrowserValid()) {
    throw new Error(Constants.UNSUPPORTED_BROWSER);
  }

  Vue.config.productionTip = false;

  if (window.appConfig) {
    setEnv(JSON.parse(atob(window.appConfig)) || {});
  }

  // Add to the Vue prototype to expose within the Vue context of components
  Vue.prototype.$RouteNames = RouteNames;
  Vue.prototype.$Constants = Constants;

  // Install the base Eclipx UI plugin
  Vue.use(Eclipx, {
    theme: euiThemes.customer,
    quasar: {
      plugins: {
        Notify,
        Dialog
      }
    }
  });

  Vue.prototype.SAIDialog = openSaiDialog;
  Vue.prototype.SAIFullScreenDialog = openSaiFullScreenDialog;

  Vue.use(EUINotify);
  Vue.use(EUINotifications);
  Vue.use(SAIAlert);
  Vue.use(VueCurrencyFilter, [
    {
      symbol: '$',
      thousandsSeparator: ',',
      fractionCount: 2,
      fractionSeparator: '.',
      symbolPosition: 'front',
      symbolSpacing: false
    }
  ]);

  // Define global filters
  Vue.filter('parseTimestamp', parseTimestamp);
  Vue.filter('parseDate', parseDate);

  const {
    VUE_APP_AUTH_DOMAIN: domain,
    VUE_APP_AUTH_CLIENT_ID: clientId,
    VUE_APP_AUTH_REALM: connection,
    VUE_APP_AUTH_AUDIENCE: audience,
    VUE_APP_GTM_ID,
    VUE_APP_GTM_AUTH,
    VUE_APP_GTM_PREVIEW,
    VUE_APP_BRANDING_SCRIPT
  } = await getEnv();

  try {
    if (VUE_APP_BRANDING_SCRIPT) {
      await loadScript(VUE_APP_BRANDING_SCRIPT);
      store.commit('user/setORGBranding', window.ORGBranding);
    }
  } catch (e) {
    // eslint-disable-next-line
    console.error(`Failed to load branding at: ${VUE_APP_BRANDING_SCRIPT}`);
  }

  // Setup Authentication with the Eclipx UI Auth0 plugin
  Vue.use(Auth0, {
    domain: domain,
    clientId: clientId,
    connection,
    audience,
    onRedirectCallback
  });

  // Add Authentication redirection
  router.beforeEach(Auth0Guard);
  router.beforeEach(storeQueryCookiesGuard());

  Vue.use(VueGtm, {
    id: VUE_APP_GTM_ID,
    queryParams: {
      gtm_auth: VUE_APP_GTM_AUTH,
      gtm_preview: VUE_APP_GTM_PREVIEW
    },
    vueRouter: router
  });

  // Add Vuelidate for component form validation
  Vue.use(Vuelidate);
  Vue.use(VueMeta);

  new Vue({
    router,
    store,
    render: (h) => h(MainApp)
  }).$mount('#app');
}

mount().catch((err) => {
  // eslint-disable-next-line
  console.error(err);
  new Vue({
    render: (h) => h(SAIUnsupportedBrowser)
  }).$mount('#app');
});
